const apiEndpoint = {
	signInApi: 'verify_mob_number',
	// verify: 'profile',
	logoutApi: 'logout',
	getStudentMessages:'get_student_messages',
	studentMsgsReply:'student_msgs_reply',
	getStudentFees:'get_student_fees',
	viewAssignemt:'view_assignments',
	mediaGallery:'media_gallery',
	getTimeTable:'view_timetable_pdf',
	createRazorpayTxnId:'create_razorpay_txn_id',
	razorpayCallBack:'razorpay_callBack',
	myLibraryBooks:'my_library_books',
	reserveBook:'student_reserve_book',
	libraryBooksData:'library_books_data',
	getStudentFeesTotals:'get_student_fees_totals',
	getStudentAttendance:'student_attendance',
	userAttendance:'user_attendance',
	studentMessagesReplies:'student_messages_replies',
	paymentGatewayDetails:'payment_gateway_status2',
};

export default apiEndpoint;